export default "__VITE_ASSET__Z8yNnk6o__"